import React, { useEffect, useState } from "react";
import { FAQ } from "../../ApiServices/FAQ/FAQApi";
import batuk from "../../assets/images/new/fav-removebg-preview.png";
import { useLocation } from "react-router-dom";

const FAQSection = ({ languageID }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const location = useLocation()
  const [faqs, setFaqs] = useState([]);
  useEffect(() => {
    if (location?.pathname !== '/webinar' && languageID === undefined) {
      GetFAQListData();
    } else {
      setFaqs(languageID === 1 ? FaqObjMarathi :languageID === 2 ? FaqObjHindi :languageID === 3 ?FaqObjAshta : FaqObj)
    }
  }, []);

  const GetFAQListData = async () => {
    // debugger;
    try {
      const response = await FAQ();
      if (response) {
        if (response?.ResponseCode == 0) {
          if (response?.DATA) {
            const List = response?.DATA || [];
            setFaqs(List);
          }
        } else {
          console.error(response?.data?.errorMessage);
        }
      }
    } catch (error) {
      // setLoader(false);
      console.log(error);
    }
  };


  const FaqObj = [
    {
      QUESTION: "Who can attend this webinar?",
      ANSWER: "Anyone interested in learning the step-by-step process of Ganesh Puja, whether beginners or experienced devotees.",
    },
    {
      QUESTION: "In which language will the webinar be conducted?",
      ANSWER: "The webinar will be conducted in easy-to-understand language, with explanations in both English and Marathi.",
    },
    {
      QUESTION: "What topics will be covered in the webinar?",
      ANSWER: ` Detailed Ganesh Puja process: Sankalpa, offerings, Aarti, etc.
- Importance and meaning of each ritual
- Do’s & don’ts for a spiritual and meaningful celebration
- Practical tips and common mistakes to avoid`,
    },
    {
      QUESTION: "Will I get a recording if I miss the live session?",
      ANSWER: "No, we encourage you to participate in live session for maximum benefits.",
    },
    {
      QUESTION: "Can I ask questions during the webinar?",
      ANSWER: "Yes. However, considering the limited time available during the webinar, we'll note down your queries and we'll call you later for clarification on your query.",
    },
    // {
    //   QUESTION: "Why is it important How Volunteer?",
    //   ANSWER:
    //     "There are many variations of passages the majority have suffered alteration in some form injected humour, or randomised words.",
    //   color: "#399be7",
    // },
  ];
  const FaqObjMarathi = [
    {
      QUESTION: "पितृ पक्षाचे महत्त्व काय आहे??",
      ANSWER:
        "पितृ पक्ष हे पूर्वजांची आठवण आणि त्यांची साधना करण्याचा पवित्र कालावधी आहे. या काळात श्राद्ध, तर्पण, पिंडदान अशा विधींनी पूर्वजांना तृप्त केले जाते. असा विश्वास आहे की पूर्वजांचा देव आर्यमा असून तो आपल्या पिढ्यांचा रक्षण करणारा देवता आहे. या काळात पितरांचे आत्मा पृथ्वीवर अवतरित होतात आणि त्यांना अन्न, जल व दान मिळते तर ते समाधानाने मुक्ती (मोक्ष) प्राप्त करतात.",
      color: "#ffa415",
    },
    {
      QUESTION: "पितृ पक्षात पूर्वजांसाठी पूजा का करावी?",
      ANSWER:
        "पूजा करून आणि श्राद्ध करून पूर्वजांच्या आत्म्यांना संतृप्त केले जाते. यामुळे त्यांच्या कल्याणासाठी आशीर्वाद मिळतो. तसेच, पूर्वजांची त्वार, शांती व मुक्ती होण्याचा मार्ग सुगम होतो. ज्यांना पूर्वजांचा ऋण भागवायचा असेल, त्यांच्यासाठी ही प्रक्रिया अतिशय आवश्यक आहे. हे पूजा करण्याने पितृदोष आणि इतर कुटुंबातील दोष दूर होतात आणि वंशाला कल्याण मिळते.",
      color: "#fc5528",
    },
    {
      QUESTION: "पितृ पक्षाच्या पूजेमुळे कसे फायदे होतात?",
      ANSWER:
        "पूर्वजांना संतुष्ट केल्याने कुटुंबात शांती, समृद्धी, सुख-शांती आणि मानसिक समाधान प्राप्त होते. बाधा, अडथळे आणि पितृदोष यांच्यापासून संरक्षण मिळते. धार्मिक दृष्टिकोनातून पाहता, अशा विधींमुळे आत्म्यांना स्वर्ग व मोक्ष प्राप्त होण्याचा मार्ग मोकळा होतो. त्यामुळे आपल्या वर्तमान व भविष्य यावर सकारात्मक परिणाम होतो.",
      color: "#8139e7",
    },
    {
      QUESTION: " जर पितृ पक्षाचे पालन न केल्यास काय होऊ शकते?",
      ANSWER:
        "जर पितृ पक्षाच्या विधी अपूर्ण राहिले किंवा पूजा न केली तर तो परिवारावर नकारात्मक परिणाम करू शकतो. अशा कुटुंबात वारंवार आर्थिक समस्या, कुटुंब कलह, आरोग्यदोष, संतानासंबंधी अडचणी, अशांतता आणि जीवनात अडथळे येऊ शकतात. असे मानले जाते की, पितरांना तृप्ती न मिळाल्यास ते असंतुष्ट राहत आणि त्यांचा शाप कुटुंबावर येतो.अशा प्रकारे पितृ पक्ष वैदिक धर्माप्रमाणे पूर्वजांचा ऋण फेडण्याचा, त्यांना शांती मिळवून देण्याचा आणि जीवनावरील नकारात्मक प्रभाव कमी करण्याचा महत्त्वाचा काळ आहे. याचा सन्मान आणि विधी अचूक केल्याने कुटुंबाच्या समृद्धी व सुखासाठी अनुकूल परिणाम होतात.  ",
      color: "#8139e7",
    },

   


    // {
    //   QUESTION: "Why is it important How Volunteer?",
    //   ANSWER:
    //     "There are many variations of passages the majority have suffered alteration in some form injected humour, or randomised words.",
    //   color: "#399be7",
    // },
  ];
  const FaqObjHindi = [
    {
      QUESTION: "पितृ पक्ष का महत्व क्या है?",
      ANSWER:
        "पितृ पक्ष पूर्वजों को याद करने और उनकी पूजा करने का एक पवित्र काल है। इस दौरान पितरों को प्रसन्न करने के लिए श्राद्ध, तर्पण, पिंडदान जैसे अनुष्ठान किए जाते हैं। ऐसा माना जाता है कि पितरों के देवता अर्यमा हैं और वे हमारी पीढ़ियों की रक्षा करने वाले देवता हैं। इस अवधि में पितरों की आत्माएँ पृथ्वी पर अवतरित होती हैं और यदि उन्हें भोजन, जल और दान प्राप्त होता है, तो वे तृप्त होकर मोक्ष प्राप्त करते हैं।",
      color: "#ffa415",
    },
    {
      QUESTION: "पितृ पक्ष में पितरों की पूजा क्यों करनी चाहिए?",
      ANSWER:
        "पूजा और श्राद्ध करने से पितरों की आत्माएँ तृप्त होती हैं। इससे उनके कल्याण का आशीर्वाद मिलता है। साथ ही, पितरों के कल्याण, शांति और मुक्ति का मार्ग सुगम हो जाता है। यह प्रक्रिया उन लोगों के लिए अत्यंत आवश्यक है जो अपने पूर्वजों का ऋण चुकाना चाहते हैं। इस पूजा को करने से पितृ दोष और अन्य पारिवारिक दोष दूर होते हैं और वंश का कल्याण होता है।",
      color: "#fc5528",
    },
    {
      QUESTION: "पितृ पक्ष पूजा के क्या लाभ हैं?",
      ANSWER:
        "पितरों को प्रसन्न करने से परिवार में शांति, समृद्धि, सुख और मानसिक संतुष्टि आती है। यह बाधाओं, विघ्नों और पितृ दोषों से सुरक्षा प्रदान करता है। धार्मिक दृष्टि से, ऐसे अनुष्ठान आत्माओं को स्वर्ग और मोक्ष प्राप्ति का मार्ग प्रशस्त करते हैं। इसका हमारे वर्तमान और भविष्य पर सकारात्मक प्रभाव पड़ता है।",
      color: "#8139e7",
    },
    {
      QUESTION: "पितृ पक्ष का पालन न करने पर क्या हो सकता है?",
      ANSWER:
        "यदि पितृ पक्ष के अनुष्ठान अधूरे हैं या उनकी पूजा नहीं की जाती है, तो इसका परिवार पर नकारात्मक प्रभाव पड़ सकता है। ऐसे परिवार को बार-बार आर्थिक समस्याएँ, पारिवारिक कलह, स्वास्थ्य समस्याएँ, संतान संबंधी समस्याएँ, अशांति और जीवन में बाधाओं का सामना करना पड़ सकता है। ऐसा माना जाता है कि यदि पूर्वज संतुष्ट नहीं होते हैं, तो वे असंतुष्ट रहते हैं और उनका श्राप परिवार पर पड़ता है। इस प्रकार, वैदिक धर्म के अनुसार पितृ पक्ष पूर्वजों के ऋण चुकाने, उन्हें शांति प्रदान करने और जीवन पर पड़ने वाले नकारात्मक प्रभाव को कम करने का एक महत्वपूर्ण समय है। इसका सम्मान करने और अनुष्ठानों को सही ढंग से करने से परिवार की समृद्धि और खुशी के लिए अनुकूल परिणाम मिलते हैं।",
      color: "#8139e7",
    },

   


    // {
    //   QUESTION: "Why is it important How Volunteer?",
    //   ANSWER:
    //     "There are many variations of passages the majority have suffered alteration in some form injected humour, or randomised words.",
    //   color: "#399be7",
    // },
  ];
   const FaqObjAshta = [
   
    {
      QUESTION: "What is the date and time of the Ashtalakshmi Homam?",
      ANSWER:
        "The homam will be performed on Saturday, 27 September 2025, from 4:00 pm to 6:00 pm (IST).",
      color: "#fc5528",
    },
    {
      QUESTION: "Where is the homam taking place?",
      ANSWER:
        "The ritual will be held at Sri Etteluthuperumal Gaushala, Tirunelveli, Tamil Nadu. Devotees can participate online from anywhere.",
      color: "#8139e7",
    },
    {
      QUESTION: " How much does it cost to book a family participation?",
      ANSWER:
        "The booking charge is ₹750 per family, which includes inclusion of your family names in the sankalpa (prayer) and access to the live stream.",
      color: "#8139e7",
    },
     {
      QUESTION: "How do I join the live stream on the day of the event?",
      ANSWER:
        "After completing your booking, you will receive a confirmation email or WhatsApp message containing the secure live-stream link.",
      color: "#ffa415",
    },
    {
      QUESTION: "Can I send my details for sankalpa if I cannot attend live?",
      ANSWER:
        "Yes. Even if you cannot watch live, you can share your family names and gotra details during booking. ",
      color: "#ffa415",
    },

   


    // {
    //   QUESTION: "Why is it important How Volunteer?",
    //   ANSWER:
    //     "There are many variations of passages the majority have suffered alteration in some form injected humour, or randomised words.",
    //   color: "#399be7",
    // },
  ];
  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="faq-one faq-one--page">
      <div
        className="container"
        style={{ display: "flex", flexDirection: "column" }}
      >
        <div className="sec-title text-center">
          {languageID === 1 ? (
            <>
              <h6
                className="sec-title__tagline bw-split-in-right"
                style={{
                  perspective: "400px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img className="tagline-img" src={batuk} alt="" /> प्रश्न आणि उत्तरे
              </h6>
              <h3
                className="sec-title__title bw-split-in-left"
                style={{ perspective: "400px", textAlign: "center" }}
              >

              </h3>
            </>
          
          ) : 
          languageID === 2 ? (
            <>
              <h6
                className="sec-title__tagline bw-split-in-right"
                style={{
                  perspective: "400px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img className="tagline-img" src={batuk} alt="" /> प्रश्न और उत्तर
              </h6>
              <h3
                className="sec-title__title bw-split-in-left"
                style={{ perspective: "400px", textAlign: "center" }}
              >

              </h3>
            </>
          
          ):
           languageID === 3 ? (
            <>
              <h6
                className="sec-title__tagline bw-split-in-right"
                style={{
                  perspective: "400px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img className="tagline-img" src={batuk} alt="" /> Frequently Asked Questions
              </h6>
              <h3
                className="sec-title__title bw-split-in-left"
                style={{ perspective: "400px", textAlign: "center" }}
              >

              </h3>
            </>
          
          )
          
          : (
            <>
              <h6
                className="sec-title__tagline bw-split-in-right"
                style={{
                  perspective: "400px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img className="tagline-img" src={batuk} alt="" /> FAQ's
              </h6>
              <h3
                className="sec-title__title bw-split-in-left"
                style={{ perspective: "400px", textAlign: "center" }}
              >
                Frequently Asked Questions.
              </h3>
            </>
          )}
        </div>
        <div className="row">
          <div className="col-xl-2"></div>
          <div className="col-xl-12">
            <div className="faq-one__accordion careox-accordion">
              {faqs.map((faq, index) => (
                <div
                  key={index}
                  className={`accrodion ${activeIndex === index ? "active" : ""
                    }`}
                  style={{ "--accent-color": faq.color }}
                >
                  <div
                    className="accrodion-title"
                    onClick={() => toggleFAQ(index)}
                  >
                    <h4>
                      <span
                        className="accrodion-title__number"
                        style={{ marginRight: "10px", fontWeight: "500" }}
                      ></span>
                      {faq.QUESTION}
                      <span className="accrodion-title__icon"></span>
                    </h4>
                  </div>
                  <div
                    className="accrodion-content"
                    style={{
                      maxHeight: activeIndex === index ? "200px" : "0",
                      overflow: "hidden",
                      transition: "max-height 0.5s ease-in-out",
                    }}
                  >
                    <div className="inner">
                      <p>{faq.ANSWER}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="col-xl-2"></div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
